#import "../fragments/form-fragment.graphql"

mutation DiscardForm($input: FormDiscardChangesInput!) {
    formDiscardChanges(input: $input) {
        form {
            ...FormFragment
        }
    }
}
